import { Zalacznik } from "../../wspolne/zalacznik";

export class ImportujEwidencjeModel {
    czyNadpisac: boolean;
    zalacznik: Zalacznik;
    projektId: string;
}